import { isPlatformBrowser } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WebSiteUsersService } from './../../../services/webSiteUsers/webSiteUsers.service';
import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef, HostListener, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { localStorageService } from '@app/services/localStorage/localStorage.service';

declare var window: any;
@Component({
    selector: 'top-navig',
    templateUrl: 'top-navig.component.html',
    styleUrls: ['top-navig.component.scss']
})

export class TopNavigComponent {
    isCollapsed = true;
    config = { ignoreBackdropClick: true };
    log: boolean = false;
    customerName: string = '';
    order: any = { elementsNbr: 0 };
    @ViewChild('navbar') navbar: ElementRef
    subscriptions: Subscription[] = [];
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    orderType: number;
    setBag = false;
    @HostListener('window:scroll', ['$event'])
    onWindowScroll(event) {
        if (event.path[1].pageYOffset >= 200) {
            document.getElementById('nav-menu').classList.add("add-background");
        } if (event.path[1].pageYOffset < 200) {
            document.getElementById('nav-menu').classList.remove("add-background");
        }
    }
    constructor(
        public router: Router,
        private webSiteUsersService: WebSiteUsersService,
        private localStorage: localStorageService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        let sub = this.webSiteUsersService.listener.subscribe(
            log => {
                this.log = log
            }
        )
        this.subscriptions.push(sub);
        if (isPlatformBrowser(this.platformId)) {
            router.events.subscribe((val) => {
                let i = window.location.href.indexOf('/carte')
                if (i > -1) {
                    this.setBag = true;
                } else {
                    this.setBag = false;
                }
            });
        }
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) == 0 && this.router.url.indexOf(routename + '/') == -1;
    }

    logout() {
        this.localStorage.clear();
        this.webSiteUsersService.listener.next(false);
        this.router.navigate(['/']);
    }

    // @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    //     if(window.pageYOffset>0){
    //         this.navbar.nativeElement.classList.add('navbar-scroll')
    //     }else{
    //         this.navbar.nativeElement.classList.remove('navbar-scroll')
    //     }
    // }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    ngOnDestroy() {
        this.unsubscribe();
    }
}
